module.exports = __webpack_public_path__ + "img/mrq.947dca39.jpg";